import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import XSSTranslate from 'components/XSSTranslate';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Hero from 'components/Hero';
import ViewContainer from 'components/ViewContainer';
import StandardContainer from 'components/StandardContainer';
import LocaleNavLink from 'components/LocaleNavLink';
import { CONTACT_US } from 'constants/route';
import gfbImg from 'assets/img/p2/p-content-1.png';
import fcImg from 'assets/img/p2/p-content-2.png';
import govImg from 'assets/img/p2/p-content-3.png';
import othersImg from 'assets/img/p2/p-content-4.png';
import classNames from 'classnames';
import expLogo from 'assets/img/p2/logo-exp.svg';
// Partners LOGO
import { partnerships } from 'constants/partnerships';

import './partnerships.scss';

const LOGO_ROW_COUNT = 5;

class Partnerships extends Component {

    getPartnersList = (isExpanded) => {
        const list = partnerships.map((item, index) => {
            let result = [];
            if ( isExpanded &&
                index &&
                index < partnerships.length -1 &&
                index % LOGO_ROW_COUNT === 0) {
                result.push({ id: index.toString, style: 'is-break'});
            }

            result.push(item);

            return result;
        }).flat();
        return list;
    }

    renderBreakItem = (index) => {
        return (<li className="partners-item is-break" key={ index }></li>);
    }

    renderPartnersList = () => {
        const isExpanded = !!(partnerships.length % LOGO_ROW_COUNT === 1);
        const list = this.getPartnersList(isExpanded);

        const style = classNames({
            'partners-list': true,
            'is-expanded': isExpanded,
        });
        return (
            <ul className={ style }>
                {
                    list.map(item => (
                        <li className={ 'partners-item ' + (item.style || '') } key={ item.id } >
                            {
                                (item.logo) ? <img src={ item.logo } alt=""/> : null
                            }
                        </li>
                    ))
                }
            </ul>
        );
    }

    render () {
        const XSSWhiteList = {
            span: ['class'],
        };
        return (
            <ViewContainer className="partnerships">
                <Header show bgdark sticky />
                <Hero bgdark>
                    <img className="logo" src={ expLogo } alt={ I18n.t('partnerships.title') } />
                    <XSSTranslate className="para" value="partnerships.hero-caption-1" tag="p" whiteList={ XSSWhiteList } />
                    <Translate className="para" value="partnerships.hero-caption-2" tag="p" />
                </Hero>
                <StandardContainer className="features">
                    <section className="feature-wrapper">
                        <div className="col image">
                            <img src={ gfbImg } alt={ I18n.t('partnerships.gfb-caption') } />
                        </div>
                        <div className="col description">
                            <XSSTranslate value="partnerships.gfb-caption" className="caption" tag="h3" whiteList={ XSSWhiteList } />
                            <XSSTranslate value="partnerships.gfb-intro" className="content" tag="p" whiteList={ XSSWhiteList } />
                            <LocaleNavLink to={ CONTACT_US } className="btn btn-primary btn-cta">
                                <Translate value="partnerships.cta-btn" />
                            </LocaleNavLink>
                        </div>
                    </section>
                    <section className="feature-wrapper">
                        <div className="col image">
                            <img src={ fcImg } alt={ I18n.t('partnerships.fc-caption') } />
                        </div>
                        <div className="col description">
                            <XSSTranslate value="partnerships.fc-caption" className="caption" tag="h3" whiteList={ XSSWhiteList } />
                            <XSSTranslate value="partnerships.fc-intro" className="content" tag="p" whiteList={ XSSWhiteList } />
                            <LocaleNavLink to={ CONTACT_US } className="btn btn-primary btn-cta">
                                <Translate value="partnerships.cta-btn" />
                            </LocaleNavLink>
                        </div>
                    </section>
                    <section className="feature-wrapper">
                        <div className="col image">
                            <img src={ govImg } alt={ I18n.t('partnerships.gov-caption') } />
                        </div>
                        <div className="col description">
                            <XSSTranslate value="partnerships.gov-caption" className="caption" tag="h3" whiteList={ XSSWhiteList } />
                            <Translate value="partnerships.gov-intro" className="content" tag="p" />
                            <LocaleNavLink to={ CONTACT_US } className="btn btn-primary btn-cta">
                                <Translate value="partnerships.cta-btn" />
                            </LocaleNavLink>
                        </div>
                    </section>
                    <section className="feature-wrapper">
                        <div className="col image">
                            <img src={ othersImg } alt={ I18n.t('partnerships.others-caption') } />
                        </div>
                        <div className="col description">
                            <Translate value="partnerships.others-caption" className="caption" tag="h3" />
                            <Translate value="partnerships.others-intro" className="content" tag="p" />
                            <LocaleNavLink to={ CONTACT_US } className="btn btn-primary btn-cta">
                                <Translate value="partnerships.cta-btn" />
                            </LocaleNavLink>
                        </div>
                    </section>
                </StandardContainer>
                <StandardContainer className="feature-partners">
                    <XSSTranslate value="partnerships.partners-caption" tag="h2" whiteList={ XSSWhiteList } />
                    {
                        this.renderPartnersList()
                    }
                </StandardContainer>
                <Footer />
            </ViewContainer>
        );
    }
}
export default connect(state => ({ i18n: state.i18n }))(Partnerships);
